"use strict";
exports.__esModule = true;
function getDeviceTransactionConfig(_a) {
    var _b = _a.status, amount = _b.amount, estimatedFees = _b.estimatedFees;
    var fields = [
        {
            type: "stellar.network",
            label: "Network"
        },
    ];
    if (!amount.isZero()) {
        fields.push({
            type: "amount",
            label: "Amount"
        });
    }
    fields.push({
        type: "stellar.memo",
        label: "Memo"
    });
    //NB device displays [none] for an empty memo
    if (estimatedFees && !estimatedFees.isZero()) {
        fields.push({
            type: "fees",
            label: "Fees"
        });
    }
    return fields;
}
exports["default"] = getDeviceTransactionConfig;
//# sourceMappingURL=deviceTransactionConfig.js.map